import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FB, LINKEDIN, TWITTER, YOUTUBE } from '../links';

const useStyles = makeStyles(theme => ({
  subTitle: {
    marginBottom: theme.spacing(10),
    fontWeight: 400
  },
  content: {
    marginTop: theme.spacing(15)
  },
  addressWrap: {
    padding: theme.spacing(12),
    borderTop: `1px solid ${theme.palette.primary.main}`,
  },
  socialLinks: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

const ContactInfoBlock = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.content}>
      {/* Address */}
      <div className={classes.addressWrap}>
        <Typography variant="body1" align="center">
          43 Heritage Dr ,
          <br /> East Hanover, NJ 07936
        </Typography>
      </div>

      {/* Social links */}
    </div>
  );
};

export default ContactInfoBlock;
